import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=49d45622&scoped=true&"
import script from "./QuestionModal.vue?vue&type=script&lang=js&"
export * from "./QuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionModal.vue?vue&type=style&index=0&id=49d45622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d45622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d45622')) {
      api.createRecord('49d45622', component.options)
    } else {
      api.reload('49d45622', component.options)
    }
    module.hot.accept("./QuestionModal.vue?vue&type=template&id=49d45622&scoped=true&", function () {
      api.rerender('49d45622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/campaign/QuestionModal.vue"
export default component.exports